import { FormGroup } from '@angular/forms';

import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';

enum Action {
    NoAction,
}

export class NoRulesRules extends FormModel<Action> {
    baseValidators: FieldValidatorsMap = {};
    formValidators: FormValidatorsMap = {};

    getNoRulesForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(Action.NoAction, formFrom);
    }
}
